import type { CourseTask } from '@school-manage/api/actions/tasks/tasks.types';

import { i18nInstance, toJSTimestamp } from '@dvb/common';
import dayjs from 'dayjs';

const { t } = i18nInstance;

export enum TaskStatus {
  ENDED = 'ENDED',
  IN_PROGRESS = 'IN_PROGRESS',
  MAX_SUBMISSIONS_REACHED = 'MAX_SUBMISSIONS_REACHED',
  NO_AVAILABLE_SUBMIT = 'NO_AVAILABLE_SUBMIT',
  NOT_STARTED = 'NOT_STARTED',
}

// 检查 task 是否在有效期内
export function getTaskStatus(data: CourseTask): TaskStatus {
  const now = dayjs();
  const start = dayjs(toJSTimestamp(data.start_at));
  const end = data.end_at ? dayjs(toJSTimestamp(data.end_at)) : null;

  if (now.isBefore(start)) return TaskStatus.NOT_STARTED;
  if (end && now.isAfter(end)) return TaskStatus.ENDED;

  if (data.config.is_advance && data.config.all_submit >= data.config.max)
    return TaskStatus.MAX_SUBMISSIONS_REACHED;

  if (data.available_submit === 0) return TaskStatus.NO_AVAILABLE_SUBMIT;

  return TaskStatus.IN_PROGRESS;
}

// 获取状态错误信息
export function getTaskStatusError(data?: CourseTask): null | string {
  if (!data) return t('noTaskFound');

  const status = getTaskStatus(data);
  const statusMessages: Partial<Record<TaskStatus, string>> = {
    [TaskStatus.ENDED]: t('courseTaskEnded'),
    [TaskStatus.MAX_SUBMISSIONS_REACHED]: t('maxSubmissionsReached'),
    [TaskStatus.NO_AVAILABLE_SUBMIT]: t('noAvailableSubmissions'),
    [TaskStatus.NOT_STARTED]: t('courseTaskNotStarted'),
  };

  return statusMessages[status] || null;
}
